export const bowtieTranslations = {
  connected_cases: 3021,
  done: 7338,
  bowtie_connect_cases: 8208,
  select_connection_type: 8209,
  inspection_evaluation: 8207,
  fetching_evaluation: 4501,
  no_evaluation_data: 5930,
  filters_header: 8640,
  filters_help_text: 8641,
  text_page_of: 8454
};

export type BowtieTranslation = {
  readonly [T in keyof typeof bowtieTranslations]: string
};

export enum BussinesType {
  notSelected = 0,
  generalCategory = 1
}

export const showOtherConnectionsAttribute = 'bowtie.option.draftModeShowOtherConnections';
